import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function ThankYou({ data, location }) {
    const params = new URLSearchParams(location?.search);
    const firstName = params.get('firstName');

    const { thankYouAddress, thankYouContactText, thankYouFacebookLink, thankYouInstagramLink, thankYouLinkedinLink, thankYouText, thankYouYoutubeLink } = data
    return (
        <div className='d-donor-detail-wrap'>
            <div className='container sm-container-1 text-center'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage src='../../../images/origins-icon.png' alt='image' />
                        </figure>
                        {firstName && (
                            <h2 className='heading-level-4-i text-uppercase green-color-1'>
                                Dear {firstName},
                            </h2>
                        )}
                        {thankYouText && parser(thankYouText)}

                        <div className='thankyou-address-sec'>
                            <p>
                                <strong>{thankYouContactText && parser(thankYouContactText)}</strong>
                            </p>
                            <ul>
                                {thankYouFacebookLink && (
                                    <li>
                                        <a href={thankYouFacebookLink} target='_blank' rel='noreferrer'>
                                            <StaticImage
                                                src='../../../images/fb-1.png'
                                                alt='Facebook icon'
                                            />
                                        </a>
                                    </li>
                                )}
                                {thankYouInstagramLink && (
                                    <li>
                                        <a
                                            href={thankYouInstagramLink}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            <StaticImage
                                                src='../../../images/ins-1.png'
                                                alt='Instagram icon'
                                            />
                                        </a>
                                    </li>
                                )}
                                {thankYouLinkedinLink && (
                                    <li>
                                        <a href={thankYouLinkedinLink} target='_blank' rel='noreferrer'>
                                            <StaticImage
                                                src='../../../images/in-1.png'
                                                alt='Linkedin icon'
                                            />
                                        </a>
                                    </li>
                                )}
                                {thankYouYoutubeLink && (
                                    <li>
                                        <a href={thankYouYoutubeLink} target='_blank' rel='noreferrer'>
                                            <StaticImage
                                                src='../../../images/yt-1.png'
                                                alt='Youtube icon'
                                            />
                                        </a>
                                    </li>
                                )}
                            </ul>
                            {thankYouAddress && parser(thankYouAddress)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
